// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

export var CALYPSO = '#00a4bd';
export var CALYPSO_DARK = '#0091ae';
export var CALYPSO_MEDIUM = '#7fd1de';
export var CALYPSO_LIGHT = '#e5f5f8';
export var SORBET = '#ff8f59';
export var SORBET_DARK = '#e68250';
export var SORBET_MEDIUM = '#ffc7ac';
export var SORBET_LIGHT = '#fff3ee';
export var LORAX = '#ff7a59';
export var LORAX_DARK = '#e66e50';
export var LORAX_MEDIUM = '#ffbcac';
export var LORAX_LIGHT = '#fff1ee';
export var MARIGOLD = '#f5c26b';
export var MARIGOLD_DARK = '#dbae60';
export var MARIGOLD_MEDIUM = '#fae0b5';
export var MARIGOLD_LIGHT = '#fef8f0';
export var CANDY_APPLE = '#f2545b';
export var CANDY_APPLE_DARK = '#d94c53';
export var CANDY_APPLE_MEDIUM = '#f8a9ad';
export var CANDY_APPLE_LIGHT = '#fdedee';
export var NORMAN = '#f2547d';
export var NORMAN_DARK = '#d94c71';
export var NORMAN_MEDIUM = '#f9aabe';
export var NORMAN_LIGHT = '#fdedf2';
export var THUNDERDOME = '#6a78d1';
export var THUNDERDOME_DARK = '#5e6ab8';
export var THUNDERDOME_MEDIUM = '#b4bbe8';
export var THUNDERDOME_LIGHT = '#f0f1fa';
export var OZ = '#00bda5';
export var OZ_DARK = '#00a38d';
export var OZ_MEDIUM = '#7fded2';
export var OZ_LIGHT = '#e5f8f6';
export var FLAT_EARTH = '#253342';
export var PANTERA = '#2d3e50';
export var OBSIDIAN = '#33475b';
export var HEFFALUMP = '#425b76';
export var SLINKY = '#516f90';
export var EERIE = '#7c98b6';
export var FLINT = '#99acc2';
export var BATTLESHIP = '#cbd6e2';
export var GREAT_WHITE = '#dfe3eb';
export var KOALA = '#eaf0f6';
export var CIRRUS = '#f2f5f8';
export var GYPSUM = '#f5f8fa';
export var OLAF = '#ffffff';
export var MONOLITH = '#000000';
export var CHART_RED = '#ea90b1';
export var CHART_ORANGE = '#fea58e';
export var CHART_YELLOW = '#f5c78e';
export var CHART_GREEN = '#a2d28f';
export var CHART_AQUA = '#51d3d9';
export var CHART_BLUE = '#81c1fd';
export var CHART_PURPLE = '#bda9ea';
export var CHART_DARK_PURPLE = '#9784c2';
export var LINK_HOVER = '#007a8c';
export var BUTTON_PRIMARY_HOVER_FILL = '#ff8f73';
export var BUTTON_SECONDARY_TEXT = '#ff7a53';
export var BUTTON_SECONDARY_HOVER_FILL = '#fff8f6';
export var BUTTON_SECONDARY_ACTIVE_FILL = '#ffebe6';
export var BUTTON_TERTIARY_LIGHT_TEXT = '#506e91';
export var BUTTON_TERTIARY_LIGHT_HOVER_FILL = '#e5eaf0';
export var BUTTON_DANGER_HOVER_FILL = '#ff5962';
export var BUTTON_DISABLED_TEXT = '#b0c1d4';
export var FOCUS_RING_BASE = '#00d0e4';
export var ALERT_DANGER = '#f04b51';
export var ALERT_WARNING = '#fdf3e1';
export var ALERT_SUCCESS = '#5967bc';
export var LINKEDIN = '#0077b5';
export var TWITTER = '#55acee';
export var FACEBOOK = '#3b5998';
export var GOOGLE = '#dd4b39';
export var XING = '#026466';
export var PINTEREST = '#bd081c';
export var RSS = '#f26522';
export var YOUTUBE = '#ff0000';
export var INSTAGRAM = '#c13584';
export var TRANSPARENT_DARK = 'rgba(0, 0, 0, 0)';
export var TRANSPARENT_LIGHT = 'rgba(255, 255, 255, 0)';
export var TRANSPARENT = 'rgba(0, 0, 0, 0)';